import { TOKEN_INFO } from '@core/constants/generic.constant';
import { AUTHPATHS } from '@core/enums/paths.enum';
import { AuthTokenModel } from '@core/models/auth.model';
import { IErrorModel } from '@core/models/generic.model';
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import moment from 'moment';
import AuthService from 'services/api/auth.service';

let refreshTokenPromise: null | Promise<string | undefined>;

const getRefreshToken = () =>
    AuthService.refresh().then((res) => {
        if (res.data.status) {
            Cookies.remove(TOKEN_INFO);
            const result = res.data.data as AuthTokenModel;
            const access_token_expires_in = result.access_token_expires_in * 60000 + moment().locale(`en`).valueOf();
            const refresh_token_expires_in = result.refresh_token_expires_in * 60000 + moment().locale(`en`).valueOf();
            const { access_token, refresh_token }: AuthTokenModel = result;
            const newAuthToken: AuthTokenModel = {
                access_token,
                refresh_token,
                access_token_expires_in,
                refresh_token_expires_in,
                token_type: `bearer`,
            };
            Cookies.set(TOKEN_INFO, JSON.stringify(newAuthToken), {
                secure: true,
                sameSite: `strict`,
                path: `/`,
            });
            refreshTokenPromise = null;
            return newAuthToken;
        }
    });

const responseHandler = (response: AxiosResponse): AxiosResponse => response;

const responseErrorHandler = (
    error: AxiosError
): AxiosError<unknown, any> | Promise<void | AxiosResponse<any, any>> => {
    // -----------------------------------------------------------------------------------------------------------------
    const originalRequest = error.config;
    const responseStatus = error?.response?.status;
    const getAuthToken = Cookies.get(TOKEN_INFO);
    const authToken: AuthTokenModel = getAuthToken ? JSON.parse(getAuthToken as unknown as string) : null;
    const currentTime = moment().locale(`en`).valueOf();
    // -----------------------------------------------------------------------------------------------------------------
    if (responseStatus === 401) {
        if (window.location.pathname === (AUTHPATHS.Login as string)) {
            const responseResult: any = error.response?.data;
            const errorResult: IErrorModel = {
                errorTitle: ``,
                errorMessage: responseResult.message,
                statusCode: 0,
            };
            return Promise.reject(errorResult);
        } else {
            if (authToken && originalRequest) {
                if (authToken.refresh_token_expires_in > currentTime) {
                    window.location.replace(AUTHPATHS.Login);
                    Cookies.remove(TOKEN_INFO);
                    // if (!refreshTokenPromise) {
                    //     refreshTokenPromise = getRefreshToken()
                    //         .then((res) => {
                    //             return res?.access_token;
                    //         })
                    //         .catch((err) => {
                    //             return Promise.reject(err);
                    //         });
                    // }
                    // return refreshTokenPromise.then((token) => {
                    //     originalRequest.headers.Authorization = `Bearer ${token}`;
                    //     return axios.request(originalRequest);
                    // });
                } else {
                    window.location.replace(AUTHPATHS.Login);
                    Cookies.remove(TOKEN_INFO);
                }
            } else {
                window.location.replace(AUTHPATHS.Login);
                Cookies.remove(TOKEN_INFO);
            }
        }
    } else {
        const responseResult: any = error.response?.data;
        const errorResult: IErrorModel = {
            errorTitle: ``,
            errorMessage: responseResult.message,
            statusCode: responseStatus ? responseStatus : 0,
            data: responseResult.data,
        };
        return Promise.reject(errorResult);
    }
    return Promise.reject(error);
};

export function responseInterceptor(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.response.use(responseHandler, responseErrorHandler);
    return axiosInstance;
}
